import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeletedUsersComponent } from './components/deleted-users/deleted-users.component';
import { UserLogsComponent } from './components/user-logs/user-logs.component';
import { Page404Component } from '../authentication/page404/page404.component';
const routes: Routes = [
  {path:"user-logs",component:UserLogsComponent},
  {path:"deleted-users",component:DeletedUsersComponent},
  {path:'*',component:Page404Component}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
